import React, { useEffect, useState, memo } from "react";
import { Image, Header } from "semantic-ui-react";
import * as auth from "../../modules/Auth/_redux/authRedux";
import Pagination from "../../components/common/CommonPagination";
import Tooltip from "react-power-tooltip";
import Moment from "react-moment";
import DataTable from "react-data-table-component";
import { useLocation, useHistory } from "react-router";
import Add from "./add";
import Edit from "./edit";
import Preview from "./preview/index";
import Filters from "./filters";
import useGetCurrentTimeAccZone from "../../../hooks/useGetCurrentTimeAccZone";
import { connect, useDispatch, useSelector } from "react-redux";
import { selectTranslations } from "../../config/i18n/slice";
import { usePermissionsSimplified } from "../../../hooks/usePermissionsSimplified";
import { AssetProfilePlaceholder } from "../../components/common/userProfilePlaceholder";
import { useDebounce } from "use-debounce";
import {
  ArrowLeft,
  ArrowRight,
  AssetNewIcon,
  AssetsNewIconBlue,
  CloseIcon,
  LinkBlueIcon,
  PlusIcon,
  SortIcon,
} from "../../../Assets/Icons/svg";
import useDisplayFormattedText from "../../../hooks/useDisplayFormattedText";
import {
  fetchAllAssetData,
  fetchAssetsInitData,
  fetchAssetsWithFilter,
} from "../../../redux/reducers/assetReducer";
import Animation from "../../components/common/CustomLoader";
import { getUserData } from "../../config/sharedApi/peopleApis";

const customStyles = {
  rows: {
    style: {
      height: "72px",
    },
  },
  headCells: {
    style: {
      paddingTop: "11px",
    },
  },
  cells: {
    style: {
      paddingLeft: "16px",
      paddingRight: "16px",
      paddingTop: "19px",
      paddingBottom: "19px",
    },
  },
};

/*
 * The `Assets` component handles the display and management of asset data, including filtering, sorting, pagination, and modals for adding, editing, and previewing assets.
 */
const Assets = (props) => {
  const { userPermissions } = usePermissionsSimplified();
  const { DisplayFormattedText } = useDisplayFormattedText();
  const dispatch = useDispatch();
  const [searchTitle, setSearchTitle] = useState("");
  const [selectedDates, setSelectedDates] = useState([]);
  const [debounceValue] = useDebounce(searchTitle, 500);
  const [sortData, setSortData] = useState();
  const [activeIndex, setActiveIndex] = useState(0);
  const [loader, setloader] = useState(false);
  const [assetUploadModal, setAssetUploadModal] = useState(false);
  const [modalWidth, setModalWidth] = useState(
    Math.max(window.innerWidth / 2, 514)
  );
  const selectedLanguage = useSelector((state) => {
    if (state?.i18n?.lang) {
      return state.i18n.lang;
    } else {
      return "en";
    }
  });

  const user = useSelector((state) => {
    if (state?.auth?.user) {
      return state.auth.user;
    } else {
      return null;
    }
  });

  const customSubStyles = {
    rows: {
      style: {
        background: "#E9F2FF",
      },
    },
    headCells: {
      style: {
        paddingTop: "4px",
        paddingBottom: "4px",
      },
    },
    cells: {
      style: {
        paddingLeft: "16px",
        paddingRight: "16px",
        paddingTop: "19px",
        paddingBottom: "19px",
      },
    },
  };
  const customChildSubStyles = {
    rows: {
      style: {
        background: "#E9F2FF80",
      },
    },
    headCells: {
      style: {
        paddingTop: "4px",
        paddingBottom: "4px",
      },
    },
    cells: {
      style: {
        paddingLeft: "16px",
        paddingRight: "16px",
        paddingTop: "19px",
        paddingBottom: "19px",
      },
    },
  };
  const t = useSelector(selectTranslations);

  const currentUserLocations = useSelector((state) => {
    if (state?.auth?.user?.id) {
      return state.auth.user.locations;
    } else {
      return null;
    }
  });

  const role = useSelector((state) => {
    if (state?.auth?.user?.id) {
      return state.auth.user.role.type;
    } else {
      return null;
    }
  });

  const allIds = [];

  currentUserLocations?.length &&
    currentUserLocations.forEach((location) => {
      if (!allIds.some((inv) => inv == location?.id)) {
        allIds.push(location?.id);
      }
    });

  const [loadUserData, setLoadUserData] = useState(false);
  const GrandChildComponent = ({ data }) => {
    const columns = [
      {
        selector: (row) => row?.attributes?.storedAssets,
        sortable: true,
        width: "47px",
      },
      {
        selector: (row) => row?.attributes?.countId,
        width: selectedLanguage === "en" ? "177px" : "190px",
        sortable: true,
        cell: (row) => (
          <span
            onClick={() => {
              if (!(role === "super_admin")) {
                if (allIds?.includes(row?.attributes?.location?.data?.id)) {
                  setTargetedData(row);
                  setTogglePreviw(true);
                }
              } else {
                setTargetedData(row);
                setTogglePreviw(true);
              }
            }}
            className="id-text-style"
          >
            {row?.attributes?.countId}
          </span>
        ),
      },
      {
        width: "268px",
        selector: (row) => row?.name,
        sortable: true,
        cell: (row) => (
          <div
            onClick={() => {
              if (!(role === "super_admin")) {
                if (allIds?.includes(row?.attributes?.location?.data?.id)) {
                  setTargetedData(row);
                  setTogglePreviw(true);
                }
              } else {
                setTargetedData(row);
                setTogglePreviw(true);
              }
            }}
          >
            {row?.attributes?.image?.data?.attributes?.url ? (
              <>
                <div className="d-flex ">
                  <Image
                    width="34px"
                    avatar
                    height="34px"
                    title={row?.attributes.name}
                    src={row?.attributes?.image?.data?.attributes?.url}
                    onClick={() =>
                      window.open(
                        row?.attributes?.image?.data?.attributes?.url,
                        "_blank"
                      )
                    }
                  />
                  <span className="id-text-style ml-4 mr-4 mt-2">
                    {DisplayFormattedText(
                      row?.grandChildAsset?.data?.attributes.name,
                      20
                    )}
                  </span>
                </div>
              </>
            ) : (
              <>
                <AssetProfilePlaceholder
                  name={`${row?.attributes.name ? row?.attributes.name : ""}`}
                  width={"34px"}
                  height={"34px"}
                />
                <span className="id-text-style ml-2 mr-2">
                  {DisplayFormattedText(row?.attributes.name, 20)}
                </span>
              </>
            )}
          </div>
        ),
      },
      {
        width: "180px",

        sortable: true,
        cell: (row) => row?.attributes?.serialNumber || t.common.na,
      },
      {
        minWidth: "150px",

        sortable: true,
        cell: (row) => (
          <span
            onClick={() => {
              if (!(role === "super_admin")) {
                if (allIds?.includes(row?.attributes?.location?.data?.id)) {
                  setTargetedData(row);
                  setTogglePreviw(true);
                }
              } else {
                setTargetedData(row);
                setTogglePreviw(true);
              }
            }}
            className=""
          >
            {row?.attributes?.location?.data?.attributes?.name
              ? DisplayFormattedText(
                  row?.attributes?.location?.data?.attributes?.name,
                  9
                )
              : t.common.na}
          </span>
        ),
      },

      {
        selector: (row) => row?.attributes?.categories,
        sortable: true,
        minWidth: "153px",
        cell: (row) => (
          <span
            onClick={() => {
              if (!(role === "super_admin")) {
                if (allIds?.includes(row?.attributes?.location?.data?.id)) {
                  setTargetedData(row);
                  setTogglePreviw(true);
                }
              } else {
                setTargetedData(row);
                setTogglePreviw(true);
              }
            }}
          >
            {DisplayFormattedText(
              row?.attributes?.categories?.data?.attributes?.name,
              10
            ) || t.common.na}
          </span>
        ),
      },

      {
        minWidth: "140px",

        sortable: true,
        cell: (row) => (
          <span
            onClick={() => {
              if (!(role === "super_admin")) {
                if (allIds?.includes(row?.attributes?.location?.data?.id)) {
                  setTargetedData(row);
                  setTogglePreviw(true);
                }
              } else {
                setTargetedData(row);
                setTogglePreviw(true);
              }
            }}
          >
            {DisplayFormattedText(row?.attributes?.model, 8) || t.common.na}
          </span>
        ),
      },

      {
        minWidth: "210px",
        sortField: "placedDate",
        name: t.assets.form.placed_in_service_date,

        sortable: true,
        cell: (row) =>
          row?.attributes?.placedDate ? (
            <div
              onClick={() => {
                if (!(role === "super_admin")) {
                  if (allIds?.includes(row?.attributes?.location?.data?.id)) {
                    setTargetedData(row);
                    setTogglePreviw(true);
                  }
                } else {
                  setTargetedData(row);
                  setTogglePreviw(true);
                }
              }}
            >
              <div>
                <Moment
                  format="DD/MM/YYYY"
                  date={row?.attributes?.placedDate}
                />
              </div>
              <div className="time-text-style text-left">
                <Moment format="h a" date={row?.attributes?.placedDate} />
              </div>
            </div>
          ) : (
            <>{t.common.na}</>
          ),
      },
      {
        minWidth: "118px",
        sortField: "status",
        name: t.assets.table.status,

        sortable: true,
        cell: (row) => (
          <span
            onClick={() => {
              if (!(role === "super_admin")) {
                if (allIds?.includes(row?.attributes?.location?.data?.id)) {
                  setTargetedData(row);
                  setTogglePreviw(true);
                }
              } else {
                setTargetedData(row);
                setTogglePreviw(true);
              }
            }}
            className={`asset pill  ${
              row?.attributes?.status === "active" ||
              row?.attributes?.status === "true"
                ? "active-green"
                : row?.attributes?.status === "inactive" ||
                  row?.attributes?.status === "false"
                ? "inactive-grey"
                : "high-low"
            }`}
          >
            {row?.attributes?.status === "active" ||
            row?.attributes?.status === "true"
              ? t.assets.active
              : row?.attributes?.status === "inactive" ||
                row?.attributes?.status === "false"
              ? t.assets.inActive
              : t.assets.disposed_asset}
          </span>
        ),
      },
    ];

    return (
      <>
        <DataTable
          columns={columns}
          onRowClicked={(row) => {
            if (!(role === "super_admin")) {
              if (allIds?.includes(row?.attributes?.location?.data?.id)) {
                setTargetedData(row);
                setTogglePreviw(true);
              }
            } else {
              setTargetedData(row);
              setTogglePreviw(true);
            }
          }}
          className="datatable-div"
          data={data}
          direction={selectedLanguage === "en" ? "ltr" : "rtl"}
          customStyles={customSubStyles}
          persistTableHead={true}
          pointerOnHover={true}
          highlightOnHover={false}
          noTableHead
        />
      </>
    );
  };

  const ExpandedComponent = memo(({ data }) => {
    const childAssets = data?.attributes?.storedAssets || [];

    const columns = [
      {
        selector: (row) => row?.attributes?.countId,
        width: selectedLanguage === "en" ? "177px" : "192px",
        sortable: true,
        cell: (row) =>
          selectedLanguage === "en" ? (
            <div
              onClick={() => {
                if (!(role === "super_admin")) {
                  if (allIds?.includes(row?.attributes?.location?.data?.id)) {
                    setTargetedData(row);
                    setTogglePreviw(true);
                  }
                } else {
                  setTargetedData(row);
                  setTogglePreviw(true);
                }
              }}
              className={`id-text-style`}
            >
              {row?.attributes?.countId}
              {row?.attributes?.grandChildAssets?.data?.length > 0 ? (
                <span
                  className="ml-2 blue-text mr-2 link-span"
                >
                  <LinkBlueIcon />
                  <span className="ml-1">
                    {row.attributes.grandChildAssets.data.length === 1
                      ? ""
                      : row.attributes.grandChildAssets.data.length}
                  </span>
                </span>
              ) : null}
            </div>
          ) : (
            <div
              onClick={() => {
                if (!(role === "super_admin")) {
                  if (allIds?.includes(row?.attributes?.location?.data?.id)) {
                    setTargetedData(row);
                    setTogglePreviw(true);
                  }
                } else {
                  setTargetedData(row);
                  setTogglePreviw(true);
                }
              }}
              className={`id-text-style d-flex`}
            >
              {row?.attributes?.countId}
              {row?.attributes?.grandChildAssets?.data?.length > 0 ? (
                <span
               
                  className="ml-2 mr-2 blue-text link-span"
                > 
                  <LinkBlueIcon />
                  <span className="ml-1">
                    {row.attributes.grandChildAssets.data.length === 1
                      ? ""
                      : row.attributes.grandChildAssets.data.length}
                  </span>
                </span>
              ) : null}
            </div>
          ),
      },
      {
        width: "268px",
        selector: (row) => row?.name,
        sortable: true,
        cell: (row) => (
          <div
            onClick={() => {
              if (!(role === "super_admin")) {
                if (allIds?.includes(row?.attributes?.location?.data?.id)) {
                  setTargetedData(row);
                  setTogglePreviw(true);
                }
              } else {
                setTargetedData(row);
                setTogglePreviw(true);
              }
            }}
          >
            {row?.attributes?.image?.data?.attributes?.url ? (
              <>
                <div className="d-flex ">
                  <Image
                    width="34px"
                    avatar
                    height="34px"
                    title={row?.attributes.name}
                    src={row?.attributes?.image?.data?.attributes?.url}
                    onClick={() =>
                      window.open(
                        row?.attributes?.image?.data?.attributes?.url,
                        "_blank"
                      )
                    }
                  />
                  <span className="id-text-style ml-4 mr-4 mt-2">
                    {DisplayFormattedText(row?.attributes.name, 20)}
                  </span>
                </div>
              </>
            ) : (
              <>
                <AssetProfilePlaceholder
                  name={`${row?.attributes.name ? row?.attributes.name : ""}`}
                  width={"34px"}
                  height={"34px"}
                />
                <span className="id-text-style ml-2 mr-2">
                  {DisplayFormattedText(row?.attributes.name, 20)}
                </span>
              </>
            )}
          </div>
        ),
      },
      {
        width: "180px",

        sortable: true,
        cell: (row) => row?.attributes?.serialNumber || t.common.na,
      },
      {
        minWidth: "150px",

        sortable: true,
        cell: (row) => (
          <span
            onClick={() => {
              if (!(role === "super_admin")) {
                if (allIds?.includes(row?.attributes?.location?.data?.id)) {
                  setTargetedData(row);
                  setTogglePreviw(true);
                }
              } else {
                setTargetedData(row);
                setTogglePreviw(true);
              }
            }}
            className=""
          >
            {row?.attributes?.location?.data?.attributes?.name
              ? DisplayFormattedText(
                  row?.attributes?.location?.data?.attributes?.name,
                  9
                )
              : t.common.na}
          </span>
        ),
      },

      {
        selector: (row) => row?.attributes?.categories,
        sortable: true,
        minWidth: "153px",
        cell: (row) => (
          <span
            onClick={() => {
              if (!(role === "super_admin")) {
                if (allIds?.includes(row?.attributes?.location?.data?.id)) {
                  setTargetedData(row);
                  setTogglePreviw(true);
                }
              } else {
                setTargetedData(row);
                setTogglePreviw(true);
              }
            }}
          >
            {DisplayFormattedText(
              row?.attributes?.categories?.data?.attributes?.name,
              10
            ) || t.common.na}
          </span>
        ),
      },

      {
        minWidth: "140px",

        sortable: true,
        cell: (row) => (
          <span
            onClick={() => {
              if (!(role === "super_admin")) {
                if (allIds?.includes(row?.attributes?.location?.data?.id)) {
                  setTargetedData(row);
                  setTogglePreviw(true);
                }
              } else {
                setTargetedData(row);
                setTogglePreviw(true);
              }
            }}
          >
            {DisplayFormattedText(row?.attributes?.model, 8) || t.common.na}
          </span>
        ),
      },

      {
        minWidth: "210px",
        sortField: "placedDate",
        name: t.assets.form.placed_in_service_date,

        sortable: true,
        cell: (row) =>
          row?.attributes?.placedDate ? (
            <div
              onClick={() => {
                if (!(role === "super_admin")) {
                  if (allIds?.includes(row?.attributes?.location?.data?.id)) {
                    setTargetedData(row);
                    setTogglePreviw(true);
                  }
                } else {
                  setTargetedData(row);
                  setTogglePreviw(true);
                }
              }}
            >
              <div>
                <Moment
                  format="DD/MM/YYYY"
                  date={row?.attributes?.placedDate}
                />
              </div>
              <div className="time-text-style text-left">
                <Moment format="h a" date={row?.attributes?.placedDate} />
              </div>
            </div>
          ) : (
            <>{t.common.na}</>
          ),
      },
      {
        minWidth: "118px",
        sortField: "status",
        name: t.assets.table.status,

        sortable: true,
        cell: (row) => (
          <span
            onClick={() => {
              if (!(role === "super_admin")) {
                if (allIds?.includes(row?.attributes?.location?.data?.id)) {
                  setTargetedData(row);
                  setTogglePreviw(true);
                }
              } else {
                setTargetedData(row);
                setTogglePreviw(true);
              }
            }}
            className={`asset pill ${
              row?.attributes?.status === "active" ||
              row?.attributes?.status === "true"
                ? "active-green"
                : row?.attributes?.status === "inactive" ||
                  row?.attributes?.status === "false"
                ? "inactive-grey"
                : "high-low"
            }`}
          >
            {row?.attributes?.status === "active" ||
            row?.attributes?.status === "true"
              ? t.assets.active
              : row?.attributes?.status === "inactive" ||
                row?.attributes?.status === "false"
              ? t.assets.inActive
              : t.assets.disposed_asset}
          </span>
        ),
      },
    ];

    return (
      <div>
        {childAssets.map((childAssetWrapper) => {
          const childAsset = childAssetWrapper.childAsset?.data;

          const grandChildAssets =
            childAssetWrapper.grandChildAsset?.data || [];

          return (
            <DataTable
              className="datatable-div"
              direction={selectedLanguage === "en" ? "ltr" : "rtl"}
              columns={columns}
              data={[childAsset]}
              expandableRows
              onRowClicked={(row) => {
                if (!(role === "super_admin")) {
                  if (allIds?.includes(row?.attributes?.location?.data?.id)) {
                    setTargetedData(row);
                    setTogglePreviw(true);
                  }
                } else {
                  setTargetedData(row);
                  setTogglePreviw(true);
                }
              }}
              expandableRowsComponent={({ data }) => (
                <GrandChildComponent data={grandChildAssets} />
              )}
              ExpanderComponentProps={{ data: grandChildAssets }}
              expandableRowDisabled={(row) =>
                grandChildAssets?.length > 0 ? false : true
              }
              customStyles={customChildSubStyles}
              persistTableHead={true}
              pointerOnHover={true}
              highlightOnHover={false}
              noTableHead
            />
          );
        })}
      </div>
    );
  });

  /* The function `handleSort` sorts data based on a specified column and sort direction */
  const handleSort = async (column, sortDirection) => {
    setloader(true);

    const sort = [`${column.sortField}:${sortDirection}`];
    setSortData(sort);
    const sortedData = await dispatch(
      fetchAssetsWithFilter({
        organisationId,
        searchName: debounceValue,
        page: page,
        pageSize: pageSize,
        location: filterOptions.locations,
        category: filterOptions.categories,
        status: filterOptions.status[0],
        serialNumber: filterOptions.serialNumber,
        placedDate:
          selectedDates.length == 1 ? [selectedDates[0]] : selectedDates,
        sort: sort,
        role,
        allIds,
      })
    );

    setloader(false);
  };

  /* The function `handleRemoveSorting` for remove sorts data */
  const handleRemoveSorting = async () => {
    setloader(true);

    const sort = undefined;
    setSortData(sort);
    const sortedData = await dispatch(
      fetchAssetsWithFilter({
        organisationId,
        searchName: debounceValue,
        page: page,
        pageSize: pageSize,
        location: filterOptions.locations,
        category: filterOptions.categories,
        status: filterOptions.status[0],
        serialNumber: filterOptions.serialNumber,
        placedDate:
          selectedDates.length == 1 ? [selectedDates[0]] : selectedDates,
        sort: sort,
        role,
        allIds,
      })
    );

    setloader(false);
  };

  /**
   * Table Fields
   */
  const columns = [
    {
      name: t.assets.table.ID,
      sortField: "countNumId",
      sortable: true,
      width: selectedLanguage == "en" ? "144px" : "160px",
      cell: (row) =>
        selectedLanguage === "en" ? (
          <div
            onClick={() => {
              if (!(role === "super_admin")) {
                if (allIds?.includes(row?.attributes?.location?.data?.id)) {
                  setTargetedData(row);
                  setTogglePreviw(true);
                }
              } else {
                setTargetedData(row);
                setTogglePreviw(true);
              }
            }}
            className={`id-text-style`}
          >
            {row?.attributes?.countId}
            {row?.attributes?.childAssets?.data?.length > 0 ? (
              <span
         
                className="ml-2 mr-2 blue-text link-span"
              >
                <LinkBlueIcon />
                <span className="ml-1">
                  {row.attributes.childAssets.data.length +
                    row?.attributes?.grandChildAssets?.data?.length ===
                  1
                    ? ""
                    : row.attributes.childAssets.data.length +
                      row?.attributes?.grandChildAssets?.data?.length}
                </span>
              </span>
            ) : null}
          </div>
        ) : (
          <div
            onClick={() => {
              if (!(role === "super_admin")) {
                if (allIds?.includes(row?.attributes?.location?.data?.id)) {
                  setTargetedData(row);
                  setTogglePreviw(true);
                }
              } else {
                setTargetedData(row);
                setTogglePreviw(true);
              }
            }}
            className={`id-text-style d-flex`}
          >
            {row?.attributes?.countId}
            {row?.attributes?.childAssets?.data?.length > 0 ? (
              <span
            
                className="ml-2 mr-2 blue-text link-span"
              >
                <LinkBlueIcon />
                <span className="ml-1">
                  {row.attributes.childAssets.data.length +
                    row?.attributes?.grandChildAssets?.data?.length ===
                  1
                    ? ""
                    : row.attributes.childAssets.data.length +
                      row?.attributes?.grandChildAssets?.data?.length}
                </span>
              </span>
            ) : null}
          </div>
        ),
    },
    {
      name: t.assets.table.name,
      sortField: "name",
      width: "300px",
      fixed: true,
      sortable: true,
      cell: (row) => (
        <div
          onClick={() => {
            if (!(role === "super_admin")) {
              if (allIds?.includes(row?.attributes?.location?.data?.id)) {
                setTargetedData(row);
                setTogglePreviw(true);
              }
            } else {
              setTargetedData(row);
              setTogglePreviw(true);
            }
          }}
        >
          {row.attributes?.image?.data?.attributes?.url ? (
            <>
              <div className="d-flex ">
                <Image
                  width="34px"
                  avatar
                  height="34px"
                  title={row.attributes.name}
                  src={row.attributes?.image?.data?.attributes?.url}
                  onClick={() =>
                    window.open(
                      row.attributes?.image?.data?.attributes?.url,
                      "_blank"
                    )
                  }
                />
                <span className="id-text-style ml-4 mr-4 mt-2">
                  {DisplayFormattedText(row?.attributes?.name, 20)}
                </span>
              </div>
            </>
          ) : (
            <>
              <AssetProfilePlaceholder
                name={`${row?.attributes?.name ? row?.attributes?.name : ""}`}
                width={"34px"}
                height={"34px"}
              />
              <span className="id-text-style ml-2 mr-2">
                {DisplayFormattedText(row?.attributes?.name, 20)}
              </span>
            </>
          )}
        </div>
      ),
    },

    {
      width: "180px",
      sortField: "serialNumber",
      name: t.assets.table.serialNumber,

      sortable: true,
      cell: (row) => row?.attributes?.serialNumber || t.common.na,
    },
    {
      minWidth: "150px",
      name: t.assets.form.location,
      sortField: "location.name",

      sortable: true,
      cell: (row) => (
        <span
          onClick={() => {
            if (!(role === "super_admin")) {
              if (allIds?.includes(row?.attributes?.location?.data?.id)) {
                setTargetedData(row);
                setTogglePreviw(true);
              }
            } else {
              setTargetedData(row);
              setTogglePreviw(true);
            }
          }}
        >
          {DisplayFormattedText(
            row?.attributes?.location?.data?.attributes?.name,
            9
          ) || t.common.na}
        </span>
      ),
    },
    {
      name: t.assets.form.category,
      sortField: "categories.name",
      minWidth: "153px",

      sortable: true,
      cell: (row) => (
        <span
          onClick={() => {
            if (!(role === "super_admin")) {
              if (allIds?.includes(row?.attributes?.location?.data?.id)) {
                setTargetedData(row);
                setTogglePreviw(true);
              }
            } else {
              setTargetedData(row);
              setTogglePreviw(true);
            }
          }}
        >
          {DisplayFormattedText(
            row?.attributes?.categories?.data?.attributes?.name,
            10
          ) || t.common.na}
        </span>
      ),
    },
    {
      minWidth: "140px",
      sortField: "model",
      name: t.assets.table.model,

      sortable: true,
      cell: (row) => (
        <span
          onClick={() => {
            if (!(role === "super_admin")) {
              if (allIds?.includes(row?.attributes?.location?.data?.id)) {
                setTargetedData(row);
                setTogglePreviw(true);
              }
            } else {
              setTargetedData(row);
              setTogglePreviw(true);
            }
          }}
        >
          {DisplayFormattedText(row?.attributes?.model, 8) || t.common.na}
        </span>
      ),
    },

    {
      minWidth: "210px",
      sortField: "placedDate",
      name: t.assets.form.placed_in_service_date,

      sortable: true,
      cell: (row) =>
        row?.attributes?.placedDate ? (
          <div
            onClick={() => {
              if (!(role === "super_admin")) {
                if (allIds?.includes(row?.attributes?.location?.data?.id)) {
                  setTargetedData(row);
                  setTogglePreviw(true);
                }
              } else {
                setTargetedData(row);
                setTogglePreviw(true);
              }
            }}
          >
            <div>
              <Moment format="DD/MM/YYYY" date={row?.attributes?.placedDate} />
            </div>
            <div className="time-text-style text-left">
              <Moment format="h a" date={row?.attributes?.placedDate} />
            </div>
          </div>
        ) : (
          <>{t.common.na}</>
        ),
    },
    {
      minWidth: "118px",
      sortField: "status",
      name: t.assets.table.status,

      sortable: true,
      cell: (row) => (
        <span
          onClick={() => {
            if (!(role === "super_admin")) {
              if (allIds?.includes(row?.attributes?.location?.data?.id)) {
                setTargetedData(row);
                setTogglePreviw(true);
              }
            } else {
              setTargetedData(row);
              setTogglePreviw(true);
            }
          }}
          className={`asset pill ${
            row?.attributes?.status === "active" ||
            row?.attributes?.status === "true"
              ? "active-green"
              : row?.attributes?.status === "inactive" ||
                row?.attributes?.status === "false"
              ? "inactive-grey"
              : "high-low"
          }`}
        >
          {row?.attributes?.status === "active" ||
          row?.attributes?.status === "true"
            ? t.assets.active
            : row?.attributes?.status === "inactive" ||
              row?.attributes?.status === "false"
            ? t.assets.inActive
            : t.assets.disposed_asset}
        </span>
      ),
    },
  ];
  const organisationId = useSelector((state) => {
    if (state?.auth?.user?.organisation) {
      return state.auth.user.organisation.id;
    } else {
      return null;
    }
  });

  const {
    data,
    isLoading: loading,
    error,
    initData,
    page,
    pageSize,
    total,
    initLoading,
  } = useSelector((state) => ({
    data: state.asset.assetData,
    isLoading: state.asset.isLoading,
    error: state.asset.error,
    initData: state.asset.assetInitData,
    page: state.asset.page,
    pageSize: state.asset.pageSize,
    total: state.asset.total,
    initLoading: state.asset.initLoading,
  }));

  const curentUrl = useLocation();
  const queryParams = new URLSearchParams(curentUrl.search);
  const assetId = queryParams.get("id");
  const childId = queryParams.get("isChild");
  const history = useHistory();

  const [filterOptions, setFilterOptions] = useState({
    categories: [],
    createdByUser: [],
    customers: [],
    locations: [],
    serialNumber: "",
    status: [],
    vendors: [],
  });

  const [toggleAsideModal, setToggleAsideModal] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [targetedData, setTargetedData] = useState();
  const [refresh, setRefresh] = useState(false);
  const [togglePreview, setTogglePreviw] = useState(false);
  const [toggleEditModal, setToggleEditModal] = useState(false);

  const location = useLocation();

  /* Fetching initial data for assets based on the `organisationId`. */
  useEffect(() => {
    const fetchData = async () => {
      setLoadUserData(true);
      if (!(role === "super_admin")) {
        const userData = await getUserData(user.id);

        dispatch(props.fulfillUser(userData));
      }
      const fetchData = dispatch(
        fetchAssetsInitData({ organisationId, role, allIds })
      );
      setLoadUserData(false);

      if (fetchData) {
        if (assetId) {
          let fetchAllData = await dispatch(
            fetchAllAssetData({ organisationId, role, allIds })
          );
          let selectedAsset = fetchAllData.payload.response.find(
            (each) => each?.attributes?.countId == assetId
          );
          if (selectedAsset) {
            setTargetedData(selectedAsset);
            setTogglePreviw(true);
            if (childId) {
              setActiveIndex(1);
            }
          } else {
            let childAssetData = [];
            let grandChildAssetData = [];

            fetchAllData.payload.response.map((each) => {
              let assetData = each?.attributes?.childAssets?.data?.find(
                (child) => child?.attributes?.countId == assetId
              );

              // Store the assetData in the variable
              if (assetData) {
                childAssetData.push(assetData);
              }
            });
            if (childAssetData?.length !== 0) {
              if (childId) {
                setActiveIndex(1);
              }
              setTargetedData(childAssetData[0]);
              setTogglePreviw(true);
            } else {
              fetchAllData.payload.response.map((each) => {
                let assetGrandData = each?.attributes?.grandChildAssets?.data?.find(
                  (child) => child?.attributes?.countId == assetId
                );

                if (assetGrandData) {
                  grandChildAssetData.push(assetGrandData);
                }

                // Store the assetData in the variable
              });

              if (grandChildAssetData?.length !== 0) {
                setTargetedData(grandChildAssetData[0]);
                setTogglePreviw(true);
              }
            }
          }
        }
      }
    };

    fetchData();
  }, [assetId]);

  return (
    <>
      <div className="new-listing-container table-header-dashboard stick-header pb-5">
        <div className="header-actions">
          <Header className="procedure-title mt-5" as="h2">
            {" "}
            <AssetNewIcon />
            {t.assets.title}
          </Header>
          <div></div>

          {userPermissions?.asset?.create && initData.length > 0 ? (
            <button
              onClick={() => {
                setToggleAsideModal(true);
              }}
              type="button"
              className="add-button asset"
            >
              <span className="add-button-text"> {t.assets.add}</span>
              <span className="add-button-img">
                <PlusIcon />
              </span>
            </button>
          ) : null}
        </div>

        <div
          className={
            initData?.length > 0
              ? "new-listing-filter wo-filter sticky-filter mt-8"
              : null
          }
        >
          <Filters
            roleData={role}
            setAssetUploadModal={setAssetUploadModal}
            assetUploadModal={assetUploadModal}
            initData={initData}
            allIds={allIds}
            data={initData}
            fileData={data}
            refresh={refresh}
            setRefresh={setRefresh}
            setFilterOptions={setFilterOptions}
            filterOptions={filterOptions}
            setSearchTitle={setSearchTitle}
            debounceValue={debounceValue}
            searchTitle={searchTitle}
            setloader={setloader}
            loader={loader}
            selectedDates={selectedDates}
            setSelectedDates={setSelectedDates}
            sortData={sortData}
            setSortdata={setSortData}
          />
        </div>
      </div>
      <div className="new-listing-container">
        {initLoading || loadUserData ? (
          <div
            className="d-flex animation-div justify-content-center align-items-center"
          
          >
            <Animation />
          </div>
        ) : (
          <div>
            <div className="new-listing-filter">
              {initData.length > 0 ? (
                <>
                  {error ? (
                    <div className="mt-8 mb-8 ">
                      <Animation />
                    </div>
                  ) : (
                    <DataTable
                      className="datatable-div"
                      columns={columns}
                      onSort={handleSort}
                      fixedHeader
                      data={data}
                      customStyles={customStyles}
                      expandableRows
                      expandableRowsComponent={ExpandedComponent}
                      expandableRowDisabled={(row) =>
                        row?.attributes?.storedAssets?.length > 0 ? false : true
                      }
                      noDataComponent={
                        initData.length > 0 ? (
                          <div className="no-data-container">
                            <div className="">
                              <p className="no-data-text">
                                {t.common.no_result_found}
                              </p>
                            </div>
                          </div>
                        ) : null
                      }
                      direction={selectedLanguage === "en" ? "ltr" : "rtl"}
                      onRowClicked={(row) => {
                        if (!(role === "super_admin")) {
                          if (
                            allIds?.includes(
                              row?.attributes?.location?.data?.id
                            )
                          ) {
                            setTargetedData(row);
                            setTogglePreviw(true);
                          }
                        } else {
                          setTargetedData(row);
                          setTogglePreviw(true);
                        }
                      }}
                      sortIcon={
                        sortData ? (
                          <div>
                            <span>
                              <SortIcon />
                            </span>
                            <span
                              onClick={(e) => {
                                e.stopPropagation();
                                handleRemoveSorting();
                              }}
                            >
                              <CloseIcon />
                            </span>
                          </div>
                        ) : (
                          <span></span>
                        )
                      }
                      persistTableHead={true}
                      pointerOnHover={true}
                      highlightOnHover={true}
                      progressPending={loader}
                      progressComponent={
                        <div className="mt-8 mb-8 ">{t.common.loading}</div>
                      }
                    />
                  )}

                  <div className="d-flex justify-content-end">
                    <Pagination
                      ofString={t.common.of}
                      total={total}
                      prevItem={
                        selectedLanguage === "en" ? (
                          <ArrowLeft />
                        ) : (
                          <ArrowRight />
                        )
                      }
                      nextItem={
                        selectedLanguage === "en" ? (
                          <ArrowRight />
                        ) : (
                          <ArrowLeft />
                        )
                      }
                      page={page}
                      limit={pageSize}
                      handleNext={async () => {
                        setloader(true);
                        await dispatch(
                          fetchAssetsWithFilter({
                            organisationId,
                            searchName: debounceValue,
                            page: page + 1,
                            pageSize: pageSize,
                            location: filterOptions.locations,
                            category: filterOptions.categories,
                            status: filterOptions.status[0],
                            serialNumber: filterOptions.serialNumber,
                            placedDate:
                              selectedDates.length == 1
                                ? [selectedDates[0]]
                                : selectedDates,
                            sort: sortData,
                            role,
                            allIds,
                          })
                        );
                        setloader(false);
                      }}
                      handlePrevious={async () => {
                        setloader(true);
                        await dispatch(
                          fetchAssetsWithFilter({
                            organisationId,
                            searchName: debounceValue,
                            page: page - 1,
                            pageSize: pageSize,
                            location: filterOptions.locations,
                            category: filterOptions.categories,
                            status: filterOptions.status[0],
                            serialNumber: filterOptions.serialNumber,
                            placedDate:
                              selectedDates.length == 1
                                ? [selectedDates[0]]
                                : selectedDates,
                            sort: sortData,
                            role,
                            allIds,
                          })
                        );
                        setloader(false);
                      }}
                    />
                  </div>
                </>
              ) : null}

              {initData.length == 0 ? (
                <div className="no-data-container">
                  <div className="no-work-orders pb-15">
                    <AssetsNewIconBlue />
                    <p className="no-data-text">
                      {t.common.there_no}{" "}
                      <span
                        className="position-relative c-pointer link-text"
                        onMouseOver={() => setShowTooltip(true)}
                        onMouseLeave={() => setShowTooltip(false)}
                      >
                        <Tooltip
                          color="#fff"
                          backgroundColor="#172B4D"
                          position="top left"
                          show={showTooltip}
                          textBoxWidth={
                            selectedLanguage == "ar" ? "66px" : "134px"
                          }
                          arrowAlign="start"
                          fontSize="14px"
                          fontWeight="400"
                          fontFamily={
                            selectedLanguage == "ar"
                              ? "Noto Kufi Arabic"
                              : "Roboto"
                          }
                          padding="0px 0px 0px 8px"
                          borderRadius="5px"
                          static
                          moveRight={selectedLanguage == "ar" ? "95px" : "70px"}
                          moveUp={selectedLanguage == "ar" ? "-2px" : "0px"}
                        >
                          <span className="work-order-tooltip">
                            {t.assets.how_to_add_assets}
                          </span>
                        </Tooltip>

                        {" " + t.assets.title + " "}
                      </span>{" "}
                      {t.common.added}
                    </p>
                    {userPermissions?.asset?.create ? (
                      <div
                     
                        className="d-flex justify-content-center part"
                      >
                        <button
                          className="work-order-button-transparent"
                          onClick={() => {
                            setToggleAsideModal(true);
                          }}
                        >
                          {t.assets.start_add_asset}
                        </button>

                        <button
                          className="work-order-button-transparent"
                          onClick={() => setAssetUploadModal(true)}
                        >
                          {t.common.bulk_upload}
                        </button>
                      </div>
                    ) : null}
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        )}

        {/* Modal component for add asset. */}
        <Add
          toggled={toggleAsideModal}
          role={role}
          allIds={allIds}
          untoggle={() => {
            setToggleAsideModal(false);
            setModalWidth(Math.max(window.innerWidth / 2, 514));
          }}
          setRefresh={setRefresh}
          refresh={refresh}
          setFilterOptions={setFilterOptions}
          filterOptions={filterOptions}
          setSearchTitle={setSearchTitle}
          setSelectedDates={setSelectedDates}
        />

        {/* Modal component for edit asset. */}
        <Edit
          role={role}
          setActiveIndex={setActiveIndex}
          allIds={allIds}
          targetedData={targetedData}
          toggled={toggleEditModal}
          untoggle={() => {
            setToggleEditModal(false);
            setTargetedData();
            setModalWidth(Math.max(window.innerWidth / 2, 514));
            history.push("/assets");
          }}
          setRefresh={setRefresh}
          refresh={refresh}
          setFilterOptions={setFilterOptions}
          setSearchTitle={setSearchTitle}
          setSelectedDates={setSelectedDates}
        />

        {/* Modal component for view assets. */}
        <Preview
          targetedData={targetedData}
          allIds={allIds}
          role={role}
          activeIndex={activeIndex}
          setActiveIndex={setActiveIndex}
          setModalWidth={setModalWidth}
          modalWidth={modalWidth}
          toggled={togglePreview}
          edit={() => {
            setTogglePreviw(false);

            setToggleEditModal(true);
          }}
          untoggle={() => {
            setTargetedData();
            setActiveIndex(0);
            setTogglePreviw(false);
            setModalWidth(Math.max(window.innerWidth / 2, 514));
            history.push("/assets");
          }}
          setRefresh={setRefresh}
          refresh={refresh}
          setFilterOptions={setFilterOptions}
          setSearchTitle={setSearchTitle}
          setSelectedDates={setSelectedDates}
        />
      </div>
    </>
  );
};
export default connect(null, auth.actions)(Assets);
